
export const SERVER_ERROR_MESSAGE = 'There is something wrong from the server!'; 
export const SAVE_SUCCESS = 'Saved successfully!';
export const SAVE_FAILED = 'Failed to save!';
export const IMAGE_HOME_BANNER = 'IMAGE_HOME_BANNER';
export const IMAGE_SUB_BANNER = 'IMAGE_SUB_BANNER';
